module.exports = __webpack_public_path__ + "img/bullet-active.325a52bc.svg";